import React from 'react';
import Color from 'color';
import styles from './styles.less';

export const ColorPill = ({ color }) => (
    <span
        className={styles['color-pill']}
        style={{
            backgroundColor: typeof color === 'string'
                ? color : new Color(color).toString()
        }}
    />
);
